module.exports = __webpack_public_path__ + "images/market_share-16225739.svg";